var map = {
	"./en/common": [
		19756
	],
	"./en/common.json": [
		19756
	],
	"./en/parent/profile": [
		91619,
		1619
	],
	"./en/parent/profile.json": [
		91619,
		1619
	],
	"./en/student/awards": [
		51583,
		1583
	],
	"./en/student/awards.json": [
		51583,
		1583
	],
	"./en/student/certificate": [
		76536,
		6536
	],
	"./en/student/certificate.json": [
		76536,
		6536
	],
	"./en/student/map": [
		70173,
		173
	],
	"./en/student/map.json": [
		70173,
		173
	],
	"./en/student/profile": [
		61754,
		1754
	],
	"./en/student/profile.json": [
		61754,
		1754
	],
	"./en/student/progress": [
		78402,
		8402
	],
	"./en/student/progress.json": [
		78402,
		8402
	],
	"./en/student/quest": [
		29329,
		9329
	],
	"./en/student/quest.json": [
		29329,
		9329
	],
	"./en/student/quiz": [
		73548,
		3548
	],
	"./en/student/quiz.json": [
		73548,
		3548
	],
	"./en/student/trophy": [
		42047,
		2047
	],
	"./en/student/trophy.json": [
		42047,
		2047
	],
	"./hi/common": [
		59056
	],
	"./hi/common.json": [
		59056
	],
	"./hi/student/awards": [
		48499,
		8499
	],
	"./hi/student/awards.json": [
		48499,
		8499
	],
	"./hi/student/certificate": [
		59772,
		9772
	],
	"./hi/student/certificate.json": [
		59772,
		9772
	],
	"./hi/student/map": [
		24081,
		4081
	],
	"./hi/student/map.json": [
		24081,
		4081
	],
	"./hi/student/profile": [
		63046,
		3046
	],
	"./hi/student/profile.json": [
		63046,
		3046
	],
	"./hi/student/progress": [
		55614,
		5614
	],
	"./hi/student/progress.json": [
		55614,
		5614
	],
	"./hi/student/quest": [
		42181,
		2181
	],
	"./hi/student/quest.json": [
		42181,
		2181
	],
	"./hi/student/quiz": [
		85112,
		5112
	],
	"./hi/student/quiz.json": [
		85112,
		5112
	],
	"./hi/student/trophy": [
		76211,
		6211
	],
	"./hi/student/trophy.json": [
		76211,
		6211
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3861;
module.exports = webpackAsyncContext;